import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  acceptedCount: number;
  rejectedCount: number;
}

const UnrecognizedAnswersSummary: FC<Props> = ({ acceptedCount, rejectedCount }) => {
  const { t } = useTranslation("unrecognizedAnswers");

  const cards = [
    { modifier: "accepted", icon: "✓", title: t("summary.accepted"), count: acceptedCount },
    { modifier: "rejected", icon: "✕", title: t("summary.rejected"), count: rejectedCount },
  ];

  return (
    <div className="unrecognized-answers-summary">
      {cards.map(({ modifier, icon, title, count }) => (
        <div
          key={modifier}
          className={`unrecognized-answers-summary__card unrecognized-answers-summary__card--${modifier}`}
        >
          <p className="unrecognized-answers-summary__title">
            <span aria-hidden="true">{icon}</span> {title}
          </p>
          <p className="unrecognized-answers-summary__count">
            <span className="unrecognized-answers-summary__number">{count}</span> {t("summary.answers", { count })}
          </p>
        </div>
      ))}
    </div>
  );
};

export default UnrecognizedAnswersSummary;
